import React from 'react';

const styles = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center'
    },
    message: {
        maxWidth: '620px',
        fontFamily: '"ClearSans", Arial, sans-serif'
    },
    title: {
        marginBottom: '12px',
        fontSize: '30px',
        lineHeight: '42px',
        fontWeight: 700,
        color: '#135CA9'
    },
    description: {
        fontSize: '18px',
        lineHeight: '24px',
        color: '#475566'
    }
};

const BlockedPage = () => {
    return (
        <div style={styles.page}>
            <div style={styles.message}>
                <div style={styles.title}>Ваша учетная запись заблокирована.</div>
                <div style={styles.description}>Свяжитесь с тех. поддержкой</div>
            </div>
        </div>
    );
};

export default BlockedPage;


// WEBPACK FOOTER //
// ./App/pages/blocked.jsx